import React from "react";
import { View, TouchableOpacity } from "react-native";
import CloseIcon from "@assets/svg/CloseIcon";
import Text from "@components/AppText";

const ModalHeader = ({ title, onClose }) => {
  return (
    <View
      style={{
        height: 60,
        flexDirection: "row",
        alignItems: "center",
        paddingLeft: 10,
      }}
    >
      <TouchableOpacity onPress={onClose}>
        <CloseIcon />
      </TouchableOpacity>
      <Text style={{ marginLeft: 20 }} fontType="head2">
        {title}
      </Text>
    </View>
  );
};

export default ModalHeader;
